/* eslint-disable no-unused-vars */

export const QUESTIONS = {
  INTRO:
    '<p>You can use this tool to calculate the total amount owed (including interest) on court-awarded civil judgments where the <a href=\'http://www.legislation.govt.nz/act/public/2016/0051/14.0/whole.html\' target="_blank" rel="noreferrer" >Interest on Money Claims Act 2016</a> has been applied. It allows you to calculate the total amount owed if paid in either a single payment or by instalments. Please refer to the <a href="fines/civil-debt-interest-calculator/calculator-faq/" target="_blank">FAQ</a> for more information, including how calculations are made and when interest applies.<br> Please note that the Act and calculator <strong>only apply to civil proceedings started after 1 January 2018. <br></strong></p>',
  QUESTION1: 'When was your debt incurred?',
  QUESTION1_2: 'How much debt was incurred on this date?',
  TOOLTIP_1:
    "<p>This is the date set by the court, <a href='http://justice.govt.nz/fines/civil-debt-interest-calculator/calculator-faq/#whatisthestartdate' target='_blank' rel='noreferrer' >see FAQ for more info.</a></p>",
  QUESTION2_TITLE:
    'Have you made or do you plan to make any payments towards this debt?',
  QUESTION2: 'Have you made any payments towards this debt?',
  QUESTION3:
    'Please add the dates and amounts of any payments you have paid or intend to pay towards this debt.',
  QUESTION4:
    'Would you like to make regular payments or a final lump sum payment? ',
  QUESTION5: 'How often would you like to pay regular payments?',
  QUESTION5_2: 'How much would each regular payment be?',
  RESULTS: 'Based on the information you have provided',
  OVERPAYMENT:
    'The balance is an overpayment because payments/instalments have been entered that exceed what is owed (the debt plus interest). This balance does not include interest on the overpayments. Select Back to return to the payments if you wish to adjust them so there is no overpayment. <a href="https://www.justice.govt.nz/fines/civil-debt-interest-calculator/calculator-faq/#whatifoverpaymentalreadymade" target="_blank" rel="noreferrer" >Go to the FAQs</a> for guidance if the overpayment has already been made.',
};

export const QUESTION_1_FINISH = 'QUESTION_1_FINISH';
export const QUESTION_1_RESET = 'QUESTION_1_RESET';
export const QUESTION_2_YES = 'QUESTION_2_YES';
export const QUESTION_2_NO = 'QUESTION_2_NO';
export const QUESTION_2_BACK = 'QUESTION_2_BACK';
export const QUESTION_3_FINISHED = 'QUESTION_3_FINISHED';
export const QUESTION_3_BACK = 'QUESTION_3_BACK';
export const QUESTION_4_YES = 'QUESTION_4_YES';
export const QUESTION_4_NO = 'QUESTION_4_NO';
export const QUESTION_4_BACK = 'QUESTION_4_BACK';
export const QUESTION_5_NEXT = 'QUESTION_5_NEXT';
export const QUESTION_5_BACK = 'QUESTION_5_BACK';
export const RESULTS_FINISHED = 'RESULTS_FINISHED';
export const RESULTS_BACK = 'RESULTS_BACK';

export const WEEK = 'week';
export const FORTNIGHT = 'fortnight';
export const MONTH = 'month';

export const FREQUENCIES = [
  {
    value: WEEK,
    name: 'Weekly',
    id: 0,
  },
  {
    value: FORTNIGHT,
    name: 'Fortnightly',
    id: 1,
  },
  {
    value: MONTH,
    name: 'Monthly',
    id: 2,
  },
];

export const EARLIEST_START_DATE = new Date('01/01/2007');

export const WARNINGS = [
  {
    name: 'MAXIMUM',
    value: {
      start:
        'The multiple payment cycle that you entered exceeded the 200 payment limit per cycle.  The last payment added was on ',
      end: '.  To enter further payments, enter another multiple payment cycle or add single payments.',
    },
  },
  {
    name: 'DUPLICATE',
    value:
      'You have entered payments that occur on the same day. The entered amounts need to be combined into one payment on that day. Once you have combined the payments, press Next.',
  },
  {
    name: 'INVALID',
    value:
      'You have entered invalid information. Please review your entries and try again.',
  },
];

export const MULTIPLE_MAX_WARNING =
  'Multiple payment cycles are limited to 200 entries. If your payment cycle requires more than 200 entries you may need to create additional multiple payment cycles.';

export const PAYMENT_SCHEDULE_INTRO =
  'Select Payment Schedule button to see each payment added.';

export const PAYMENT_WARNING_INTRO =
  "<p>There may be missing or incorrect information in the payments added. Please <a href='http://justice.govt.nz/fines/civil-debt-interest-calculator/calculator-faq' target='_blank' rel='noreferrer' >see FAQ for more info.</a></p>";
